// extracted by mini-css-extract-plugin
export var editButton = "_nt-0";